import { Modal } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { AppCopyText } from 'components/ui';
import { useStores } from 'index';

type Props = {
    ticketUrl: string;
    onDialogClose: () => void;
};

const CreateTicketReponseModal = observer(({ ticketUrl: ticketUrl, onDialogClose }: Props) => {
    const { t } = useTranslation();

    const { userDiagnosticStore } = useStores();

    const handleCopyAndClose = async () => {
        try {
            await navigator.clipboard.writeText(ticketUrl);
        } finally {
            handleClose();
        }
    };

    const handleClose = () => {
        userDiagnosticStore.resetTicketResponse();
        onDialogClose();
    }

    return (
        <Modal
            title={t('UserDiagnostics.CreateTicket.Title')}
            open={userDiagnosticStore.hasTicketResponse}
            onClose={() => { handleClose() }}
            confirmBtn={{ label: t('UserDiagnostics.Action.CopyUrlClose'), onClick: () => handleCopyAndClose() }}
            cancelBtn={{ label: t('close'), onClick: () => handleClose() }}
            style={{ zIndex: 2000 }}
        >
            <div className='d-flex justify-content-between align-items-center w-100'>
                <p data-test={`systemID-cell-text`} className='mb-0 overflow-ellipsis' title={ticketUrl}>
                    {ticketUrl}
                </p>
                <AppCopyText className='ml-1 ' text={ticketUrl} />
            </div>
        </Modal>
    );
});

export default CreateTicketReponseModal;
